import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, CardItem, inject, ModalHandle, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { Collapse } from 'reactstrap';
import { ActiveDisplay } from '../../ActiveDisplay';
import { DisplaysStore } from '../../DisplaysStore';

export interface IDisplaySolarCardProps {
    readonly telemetryPoll?: Mri.TelemetryPolls.TelemetryPoll;
    readonly loading: boolean;
}

@autoinject
@observer
export class DisplaySolarCard extends React.Component<IDisplaySolarCardProps> {
    public render() {
        const measurements = this.props.telemetryPoll?.measurements;
        const collapsible = true;
        return (
            <StatusCard title="Solar Power">
                {measurements && (
                    <>
                        <CardItem
                            label="Battery Voltage"
                            value={this.measurementValue(
                                this.findMeasurement(Mri.WebApi.MeasurementId.SystemBatteryVolts)
                            )}
                        />
                        <CardItem
                            label="Voltage From Solar Panels"
                            value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.CCBattVolts))}
                        />
                        <CardItem
                            label="Current From Solar Panels"
                            value={this.measurementValue(
                                this.findMeasurement(Mri.WebApi.MeasurementId.TotalSolarBatteryChargeAmps)
                            )}
                        />
                        <CardItem
                            label="Solar Power From Panels"
                            value={this.measurementValue(
                                this.findMeasurement(Mri.WebApi.MeasurementId.TotalSolarSupplyWatts)
                            )}
                        />
                        <CardItem
                            label="Display Power Drawn"
                            value={this.measurementValue(
                                this.findMeasurement(Mri.WebApi.MeasurementId.TotalSolarLoadWatts)
                            )}
                        />
                    </>
                )}

                {collapsible && (
                    <a className="btn btn-link p-0 p-md-2" onClick={this.onToggle}>
                        {this.collapsed ? 'Expand' : 'Hide'} Solar Power
                    </a>
                )}

                <Collapse isOpen={!this.collapsed}>
                    <CardItem label="Charge Controller" value="" header />
                    <CardItem
                        label="CC Battery Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.CCBattVolts))}
                    />
                    <CardItem
                        label="CC Input Aps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.CCInputAmps))}
                    />
                    <CardItem
                        label="CC Inlet Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.CCInputVolts))}
                    />
                    <CardItem
                        label="CC Output Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.CCOuputAmps))}
                    />
                    <CardItem
                        label="CC Daily Ouput Amp Hrs"
                        value={this.measurementValue(
                            this.findMeasurement(Mri.WebApi.MeasurementId.CCDailyOutputAmpHours)
                        )}
                    />
                    <CardItem
                        label="CC Daily Output Kilowatt Hrs"
                        value={this.measurementValue(
                            this.findMeasurement(Mri.WebApi.MeasurementId.CCDailyOutputKilowattHours)
                        )}
                    />

                    <CardItem label="Inverter L1" value="" header />
                    <CardItem
                        label="Buy Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL1BuyAmps))}
                    />

                    <CardItem
                        label="Sell Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL1SellAmps))}
                    />
                    <CardItem
                        label="Charge Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL1ChargeAmps))}
                    />

                    <CardItem
                        label="AC Output Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL1ACOutputVolts))}
                    />

                    <CardItem
                        label="Output Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL1OutputAmps))}
                    />

                    <CardItem label="Inverter L2" value="" header />
                    <CardItem
                        label="Buy Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL2BuyAmps))}
                    />

                    <CardItem
                        label="Sell Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL2SellAmps))}
                    />
                    <CardItem
                        label="Charge Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL2ChargeAmps))}
                    />

                    <CardItem
                        label="AC Output Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL2ACOutputVolts))}
                    />

                    <CardItem
                        label="Output Amps"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvL2OutputAmps))}
                    />

                    <CardItem label="Inverter AC1" value="" header />
                    <CardItem
                        label="L1 Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvAC1L1Volts))}
                    />

                    <CardItem
                        label="L2 Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvAC1L2Volts))}
                    />

                    <CardItem label="Inverter AC2" value="" header />
                    <CardItem
                        label="L1 Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvAC2L1Volts))}
                    />

                    <CardItem
                        label="L2 Volts"
                        value={this.measurementValue(this.findMeasurement(Mri.WebApi.MeasurementId.InvAC2L2Volts))}
                    />
                </Collapse>
            </StatusCard>
        );
    }

    @bind
    private findMeasurement(measurementId: Mri.WebApi.MeasurementId) {
        if (this.props.telemetryPoll?.measurements) {
            return this.props.telemetryPoll.measurements.find(s => s.id == measurementId);
        }
    }

    @bind
    private measurementValue(measurement?: Mri.WebApi.Measurement) {
        if (measurement) {
            const units = measurement.units || '';
            if (measurement.boolValue) return measurement.boolValue + units;
            if (measurement.doubleValue) return measurement.doubleValue.toFixed(2) + units;
            if (measurement.floatValue) return measurement.floatValue.toFixed(2) + units;
            if (measurement.intValue) return measurement.intValue.toFixed(2) + units;
            if (measurement.stringValue) return measurement.stringValue + units;
            if (measurement.durationValue) return measurement.durationValue.toString() + units;
        } else return '-';
    }

    @bind
    @action
    private onToggle() {
        this.collapsed = !this.collapsed;
    }

    @observable
    private collapsed = true;
}
